export const feedbackCharacterLimit = 250;
export const resubmissionMessageCharacterLimit = 1500;
export const classAssignmentSubmissionPageQuery =
  'classAssignmentSubmissionPage';
export const classAssignmentListQuery = 'classAssignment';
